
import { ReducerRegistry, equals } from '../redux';

import { JWT_STORAGE, MEETING_TIMING, SET_ACCESS_TOKEN,
    SET_JWT, SET_MEETING_INFO, SET_RENDER_CONTENT, SET_USER_ROLE, SET_USER_SETTING } from './actionTypes';
import { userType } from './constants';

const jwtInfo = {
    usertype: userType,
    meetingDetails: null,
    accessToken: null,
    confSettings: null,
    localUserRole: null,
    jwtData: null,
    mtTime: null,
    isRendered: false
};

/**
 * Reduces redux actions which affect the JSON Web Token (JWT) stored in the
 * redux store.
 *
 * @param {Object} state - The current redux state.
 * @param {Object} action - The redux action to reduce.
 * @returns {Object} The next redux state which is the result of reducing the
 * specified {@code action}.
 */
ReducerRegistry.register(
    'features/base/jwt',
    (state = jwtInfo, action) => {
        switch (action.type) {
        case SET_JWT: {

            const { ...payload } = action;
            const { meetingDetails, accessToken, confSettings, localUserRole, jwtData, mtTime, isRendered } = state;
            const nextState = {
                ...payload,
                meetingDetails,
                accessToken,
                confSettings,
                localUserRole,
                jwtData,
                mtTime,
                isRendered
            };

            return equals(state, nextState) ? state : nextState;
        }

        case SET_MEETING_INFO: {
            return {
                ...state,
                meetingDetails: action.meeting
            };
        }

        case SET_ACCESS_TOKEN: {
            return { ...state,
                accessToken: action.accessToken };
        }

        case SET_USER_SETTING: {
            return { ...state,
                confSettings: action.confSetting };
        }

        case SET_USER_ROLE: {
            return { ...state,
                localUserRole: action.localUserRole };
        }

        case JWT_STORAGE: {
            return {
                ...state,
                jwtData: action.jwtData
            };
        }

        case MEETING_TIMING: {
            return {
                ...state,
                mtTime: action.mtTime
            };
        }
        case SET_RENDER_CONTENT: {
            return {
                ...state,
                isRendered: action.shouldRender
            };
        }
        }

        return state;
    });
